import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/error/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/error/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/error/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/error/locales/da/messages.mjs';
import { messages as svMessages} from '../src/raw/error/locales/sv/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages, svMessages);


export class IconError16 extends LitElement {
  render() {
      const title = i18n.t({ message: `Octagon with exclamation point`, id: 'icon.title.error', comment: 'Title for error icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-error-16-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.5 11.107 4.748 15.5h6.503l4.248-4.393V4.893L11.252.5H4.748L.5 4.893z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 11.398a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M8 8.5V3"></path></svg>`; }
}
if (!customElements.get('w-icon-error-16')) {
  customElements.define('w-icon-error-16', IconError16);
}